/**
 * Ask the API for a resized WebP of an uploaded image (`?w=`), instead of the
 * original upload (often 1–2 MB for a card-sized slot). Other URLs (external
 * images, data URIs, static assets) are returned unchanged.
 */
// Uploads, and tenant branding assets (the default course cover is a ~2 MB
// image sent to every cover-less card).
const UPLOAD_RE = /\/uploads\/file\/\d+(?:$|\?)|\/branding\/asset\/\w+(?:$|\?)/;

export function sizedImageUrl(url: string | null | undefined, width: number): string {
  if (!url || !UPLOAD_RE.test(url) || /[?&]w=/.test(url)) return url || '';
  return `${url}${url.includes('?') ? '&' : '?'}w=${width}`;
}
